<template>
	<div class="col-12">
		<h2 class="list-headline">
			<slot></slot>
		</h2>
	</div>
</template>

<script setup>
</script>
